export interface IDimensionRow {
  name: string;
  id: string;
  spend: number;
  type?: string;
}

export interface IDimensionGroup extends IDimensionRow {
  children?: IDimensionRow[];
}

export interface IAllocatedDimensionRow extends IDimensionRow {
  isAllocated?: boolean;
  isInvalid?: boolean;
}

export interface IAllocatedDimensionGroup extends IAllocatedDimensionRow {
  children?: IAllocatedDimensionRow[];
}

export interface IDimensionSelection {
  id: string;
  rootId?: string | null;
}

export interface IAllocation {
  name: string;
  id: number;
  percentage: number;
}

export interface IAllocationListItem {
  id: number;
  percentage?: number;
  name: string;
  flag?: boolean;
  groupName?: string;
}

export interface IApplicationItem {
  id: number;
  percentage?: number;
  appName: string;
  corpApp: boolean;
  groupName: string;
}

export interface IAllocatedItem {
  contribution: string;
  type?: string | null;
  dimensionId: string;
  dimensionName: string;
  rootId?: string | null;
  level?: number;
  year: number;
  items: IAllocation[];
}

export interface IProductItem {
  id: number;
  name: string;
}

export interface IAllocatedYear {
  year: number;
  allocations: IAllocatedItem[];
}

export enum DimensionTypeEnum {
  Vendors = 'Vendor',
  ServiceTowers = 'ServiceTower',
  JobRoles = 'JobRole',
  Application = 'Application',
}
